export default __webpack_public_path__ + "static/media/cage_1.c05e1bfe.svg";